// USED in videogallery2022.js, videoproduct2022.js, whybuyfromus2022.js, employment.js
const videoTranscripts4i = function(){
	let scriptButton, scriptText;
	const maxTranscriptHeight = 300; // must match value in videogallery SASS file
	
	const init = () =>{
		if(document.getElementById("transcriptContainer") !== null){
			scriptText = document.getElementById("transcriptContainer");
			scriptButton = document.getElementById("showMoreTranscript");
			if(scriptButton){
				getHeight();
				scriptButton.addEventListener("click", toggle);
				window.addEventListener("resize", getHeight);
			}
		}
	};
	
	const toggle = (e) =>{
		e.preventDefault();
		if(scriptButton.getAttribute("aria-expanded") == "false") expand();
		else collapse();
	};
	
	const expand = () =>{
		scriptButton.setAttribute("aria-expanded", "true");
		scriptText.classList.add("showAll");
		scriptText.focus();
		scriptButton.textContent = "Hide Full Transcript";
	};
	
	const collapse = () =>{
		if(scriptButton){
			scriptButton.setAttribute("aria-expanded", "false");
			scriptText.classList.remove("showAll");
			scriptButton.textContent = "Show Full Transcript";
		}
	};
	
	const getHeight = () =>{
		//if the script is less than the max height set in videogallery sass file
		//show full transcript and hide the show full transcript button
		if(scriptText.offsetHeight < maxTranscriptHeight){
			scriptButton.setAttribute("aria-expanded", "true");
			scriptText.classList.add("showAll");
			scriptButton.classList.add("hide");
		}else if(scriptButton.classList.contains("hide")){
			scriptButton.setAttribute("aria-expanded", "false");
			scriptText.classList.remove("showAll");
			scriptButton.classList.remove("hide");
		}
	};
	
	return{
		Init: init,
		Collapse: collapse,
		GetHeight: getHeight
	};
};